import config from '@@config';
import type { ImageMimeType } from '@@constants/ImageMimeTypes';
import { ELEMENT_TYPES } from '@@editor/helpers/Element';
import { createElement } from '@@editor/serialization/UnitySerializer/deserializeNodes';

export const allowedMimeTypes = Object.values(config.allowedImageMimeTypes) as ImageMimeType[];

export const INITIAL_CHILDREN = [
    createElement(ELEMENT_TYPES.EMBED_CAPTION),
    createElement(ELEMENT_TYPES.EMBED_CREDIT),
];
